import React, { ChangeEvent } from "react";
import { ImageGalleryProps } from "../../types/interface";
import {
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  LinearProgress,
  Typography,
} from "@mui/material";
import xx from "../../assets/icons/x.svg";
import { useTest } from "./TestContext";
import { VisionStudioSvg } from "../../components";
import uploadImageIcon from "../../assets/icons/uploadImage.svg";

const Uploads: React.FC<ImageGalleryProps> = ({ id }) => {
  // const drags = drags;
  const {
    filename,
    fileUpload,
    isUploading,
    progress,
    fileInputRef,
    handleFileChange,
    handleCardClick,
    handleFileDrop,
  } = useTest();

  return (
    <div>
      <Box sx={{ margin: "20px", marginBottom: "0" }}>
        <Card sx={{ padding: "10px" }} variant="outlined">
          <h3
            style={{ color: "#939393", fontWeight: "400", marginLeft: "20px" }}
          >
            {isUploading ? "Uploading" : "Upload an image to test your model"}
          </h3>

          <Card
            sx={{
              height: "calc(100vh - 270px)",
              margin: "20px",
              border: "2px dashed #B1BFD066",
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              maxHeight: "65vh",
            }}
            variant="outlined"
            onClick={handleCardClick}
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleFileDrop}
          >
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            {isUploading ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "40%",
                    border: "1px solid #E4E9F0",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                >
                  <Grid container spacing={2} sx={{ width: "100%" }}>
                    <Grid item xs={11}>
                      {fileUpload && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={URL.createObjectURL(fileUpload)}
                            alt="Drag or Click to upload"
                            style={{ width: "100px", marginRight: "5px" }} // Reduced margin
                          />
                          <div>
                            <h5 style={{ margin: "0", marginBottom: "2px" }}>
                              {filename.name}
                            </h5>
                            <h6 style={{ color: "#666", margin: "0" }}>
                              {filename.size}
                            </h6>
                          </div>
                        </div>
                      )}
                    </Grid>

                    <Grid item xs={1} style={{ alignSelf: "flex-end" }}>
                      {progress >= 100
                        ? fileUpload && (
                            <img
                              src={xx}
                              alt="Drag or Click to upload"
                              style={{ marginBottom: "10px" }}
                            />
                          )
                        : ""}
                    </Grid>
                  </Grid>

                  <Box
                    sx={{
                      width: "100%",
                      mb: 2,
                      borderBottom: "1px solid #E4E9F0",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box sx={{ width: "100%", mr: 1 }}>
                        <LinearProgress
                          variant="determinate"
                          value={progress}
                        />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          {`${Math.round(progress)}%`}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <h3 style={{ fontWeight: "400", textAlign: "center" }}>
                    Uploading your image for test.{" "}
                    <span style={{ color: "#1F4690" }}>Please Wait</span>
                    <br />
                    <span style={{ color: "#969DB2" }}>
                      Supports: PNG, JPG, JPEG
                    </span>
                  </h3>
                </Box>
              </>
            ) : (
              <Box sx={{ textAlign: "center" }}>
                <Box>
                  <IconButton>
                    <VisionStudioSvg icon={uploadImageIcon} />
                    <input
                      hidden
                      accept="image/*"
                      ref={fileInputRef}
                      type="file"
                      onChange={(e) =>
                        handleFileChange(
                          e as unknown as ChangeEvent<HTMLInputElement>
                        )
                      }
                    />
                  </IconButton>
                </Box>
                <Box display="flex" width="100%" justifyContent="center">
                  <Typography
                    variant="h6"
                    marginTop="0px"
                    sx={{
                      fontSize: "18px",
                      color: "#132A00",
                    }}
                    id="testUploadImageMain"
                  >
                    Drop your image here, or
                    <Button
                      component="label"
                      sx={{
                        fontSize: "18px",
                        textTransform: "initial",
                      }}
                    >
                      browse
                    </Button>
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ fontSize: "12px" }}
                  >
                    Supports: PNG, JPG, JPEG
                  </Typography>
                </Box>
              </Box>
            )}
          </Card>
        </Card>
      </Box>
    </div>
  );
};

export default Uploads;
